import "core-js/modules/es6.regexp.replace.js";
export var TYPES = {
  CATEGORY: 'category',
  PRODUCT: 'product',
  AGGREGATE_OFFER: 'AggregateOffer',
  OFFER: 'offer',
  HOMEPAGE: 'homepage',
  ORGANISATION: 'organisation',
  SEARCH_ACTION: 'search-action'
};
var CONTEXT = 'http://schema.org';
var BRAND = 'Maisons du Monde';
var SCHEMA_TYPES = {
  [TYPES.CATEGORY]: 'Product',
  [TYPES.PRODUCT]: 'Product',
  [TYPES.AGGREGATE_OFFER]: 'AggregateOffer',
  [TYPES.OFFER]: 'Offer',
  [TYPES.HOMEPAGE]: 'WebSite',
  [TYPES.ORGANISATION]: 'Organization',
  [TYPES.SEARCH_ACTION]: 'SearchAction'
};

var getProductDescription = product => {
  if (product.additionalInformation.metaDescription) {
    return product.additionalInformation.metaDescription;
  }

  return product.description.main ? product.description.main.replace(/\n|\r|\t|<(?:.|\n)*?>/gm, '').trim().slice(0, 150) : '';
};

var getProductAvailability = product => {
  if (product.stock.status === 'STORE_ONLY') {
    return 'InStoreOnly';
  }

  if (product.additionalInformation.buyable) {
    return 'InStock';
  }

  return 'OutOfStock';
};

var getProductPrice = (_ref) => {
  var {
    price
  } = _ref;
  return price.sales.amount ? "".concat(price.sales.amount) : "".concat(price.base.amount);
};

var SCHEMAS = {
  [TYPES.CATEGORY](category, _ref2) {
    var {
      currency
    } = _ref2;
    var {
      facets
    } = category.filters.find((_ref3) => {
      var {
        name
      } = _ref3;
      return name === 'price';
    });
    var lowPrice = 0;
    var highPrice = 0;

    try {
      lowPrice = facets.min.toFixed(2);
      highPrice = facets.max.toFixed(2);
    } catch (error) {
      console.log(error);

      if (process.client && window && window.newrelic) {
        window.newrelic.noticeError(error);
      }
    }

    return {
      '@context': CONTEXT,
      '@type': SCHEMA_TYPES[TYPES.CATEGORY],
      name: category.name,
      description: category.seo.meta_description,
      brand: BRAND,
      offers: {
        '@type': SCHEMA_TYPES[TYPES.AGGREGATE_OFFER],
        lowPrice,
        highPrice,
        offerCount: category.total,
        priceCurrency: currency
      },
      url: category.url,
      image: category.image
    };
  },

  [TYPES.PRODUCT](product) {
    return {
      '@context': CONTEXT,
      '@type': SCHEMA_TYPES[TYPES.PRODUCT],
      name: product.name,
      description: getProductDescription(product),
      image: product.images[0].src,
      brand: BRAND,
      offers: {
        '@type': SCHEMA_TYPES[TYPES.OFFER],
        availability: getProductAvailability(product),
        price: getProductPrice(product),
        priceCurrency: product.currency,
        itemCondition: 'new'
      },
      url: product.url
    };
  },

  [TYPES.HOMEPAGE](prismic, locale) {
    return {
      '@context': CONTEXT,
      '@type': SCHEMA_TYPES[TYPES.HOMEPAGE],
      url: "".concat(prismic.url, "/").concat(locale.market, "/").concat(locale.language),
      name: prismic.meta_title,
      image: prismic.thumbnail.url || '',
      publisher: {
        '@type': SCHEMA_TYPES[TYPES.ORGANISATION],
        name: BRAND
      },
      potentialAction: {
        '@type': SCHEMA_TYPES[TYPES.SEARCH_ACTION],
        target: "".concat(prismic.url, "/").concat(locale.market, "/").concat(locale.language, "/q/{search_term_string}"),
        'query-input': 'required name=search_term_string',
        keywords: prismic.keywords.map((_ref4) => {
          var {
            keyword
          } = _ref4;
          return keyword;
        }).filter(keyword => keyword).join(),
        sameAs: prismic.sameAs.map((_ref5) => {
          var {
            url: {
              url
            }
          } = _ref5;
          return url;
        }).filter(url => url)
      }
    };
  }

};

var undefinedSchema = type => () => console.warn("Schema for \"".concat(type, "\" is not defined"));

var getJsonLD = type => SCHEMAS[type] || undefinedSchema(type);

export default getJsonLD;